<template>
  <b-modal
    v-model="show"
    :title="$t('Check Payroll Payment')"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('close')"
    size="lg"
    scrollable
  >
    <div class="mb-2 mt-1">
      <b-row>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>EMPLOYEE</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="G_EMPLOYEE_INFO.empoye_name" disabled />
          </b-input-group>
        </b-col>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>AREA</strong>
              </b-input-group-text>
            </template>
            <b-form-input
              :value="G_EMPLOYEE_INFO.area"
              disabled
              class="text-uppercase"
            />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div class="table-responsive">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="items"
        :fields="fields"
        show-empty
        :empty-text="$t('No matching records found')"
      >
        <template #cell(month)="data">
          <span> {{ data.value | capitalize }} </span> <br />
        </template>

        <template #cell(actions)="data">
          <feather-icon
            icon="FileTextIcon"
            class="cursor-pointer mr-50"
            size="18"
            @click="downloadFile(data.item.month)"
          />
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import { mapGetters } from "vuex";

export default {
  props: {
    employeeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      fields: [
        {
          key: "month",
          label: this.$t("Period"),
        },
        {
          key: "actions",
          label: this.$t("File"),
        },
      ],
      items: [],
    };
  },

  async created() {
    await this.$store.dispatch(
      "RRHHEmployeesStore/A_EMPLOYEE_INFO",
      this.employeeId
    );
    await this.getPayrollDates();
  },
  methods: {
    async downloadFile(month) {
      try {
        this.addPreloader();
        let params = {
          employee_id: this.employeeId,
          period: month,
        };
        const response = await EmployeeService.getPayrollPdf(params);
        await this.forceFileDownloadPdf(response);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getPayrollDates() {
      try {
        this.addPreloader();
        const params = {
          employee_id: this.employeeId,
          personal_type: this.G_EMPLOYEE_INFO.personal_type,
        };
        const { data } = await EmployeeService.getPayrollDates(params);
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
  computed: {
    ...mapGetters({
      G_EMPLOYEE_INFO: "RRHHEmployeesStore/G_EMPLOYEE_INFO",
    }),
  },
};
</script>

<style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>